<template>
    <client-page>
        <guide-visual v-bind="visual" />

        <section>
            <v-card img="/images/guide/legacy/legacy-introduction-bg.jpg" tile flat color="#085848" class="py-60 py-lg-120">
                <v-container>
                    <p class="tit tit--sm font-size-lg-28 font--serif font-weight-medium text-center legacy-accent">
                        <strong>The With-CAN</strong>(위드캔 레거시 클럽)은 <br class="d-sm-none" />
                        귀한 유산을 <br class="d-none d-md-block" />
                        사회에 영원히 남기며, 다음 세대와 공동체의 희망을 실현하는 사람들의 모임입니다.
                    </p>
                </v-container>
            </v-card>
        </section>

        <div class="client-content-wrap grey-fa">
            <scrolldown-tail />

            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">유산기부 종류</h2>
                    </div>

                    <v-row class="row--xs">
                        <v-col v-for="(type, index) in types" :key="index" cols="6" lg="4">
                            <v-card flat class="type-card">
                                <v-card-title class="justify-center pt-52">
                                    <v-img :src="type.icon" max-width="60" alt="" />
                                </v-card-title>
                                <v-card-text class="pb-52">
                                    <div class="tit tit--sm legacy-accent text-center">
                                        {{ type.name }}
                                    </div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </section>
        </div>

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">유산기부 절차</h2>
                    </div>

                    <v-img src="/images/guide/legacy/process-list.png" alt="" class="d-md-none" />

                    <div class="d-none d-md-block">
                        <v-row class="process-list row--lg">
                            <v-col v-for="(item, index) in process" :key="index" cols="12">
                                <v-card color="#BD9E7A" outlined flat class="process-card">
                                    <v-row class="text-center">
                                        <v-col cols="12">
                                            <div class="font--serif legacy-color font-weight-bold font-size-28">0{{ index + 1 }}</div>
                                            <div v-html="item.name" class="client-title--xs font-weight-bold mt-16" />
                                            <v-img :src="`/images/guide/legacy/process-${index + 1}.svg`" max-width="60" class="my-28 mx-auto" />
                                            <p v-html="item.text" class="page-text page-text--lg" />
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </v-col>
                        </v-row>
                    </div>
                </v-container>
            </section>
        </div>

        <div class="client-content-wrap respect-bg">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">후원자 예우</h2>
                    </div>

                    <v-row justify="center">
                        <template v-for="(item, index) in respect">
                            <v-col v-if="index < 2" :key="index" cols="12" md="6" lg="4">
                                <v-card color="#0C312C" max-width="384" flat class="border-radius-16 h-100 mx-auto text-center">
                                    <v-img :src="item.image" alt="" />
                                    <v-card-title class="justify-center pt-lg-40">
                                        <div class="legacy-accent tit tit--sm">
                                            {{ item.title }}
                                        </div>
                                    </v-card-title>
                                    <v-card-text class="pb-lg-40">
                                        <p v-html="item.texts" class="page-text page-text--lg white--text" />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </template>
                    </v-row>
                    <v-row justify="center">
                        <template v-for="(item, index) in respect">
                            <v-col v-if="index >= 2" :key="index" cols="12" md="6" lg="4">
                                <v-card color="#0C312C" max-width="384" flat class="border-radius-16 h-100 mx-auto text-center">
                                    <v-img :src="item.image" alt="" />
                                    <v-card-title class="justify-center pt-lg-40">
                                        <div class="legacy-accent tit tit--sm">
                                            {{ item.title }}
                                        </div>
                                    </v-card-title>
                                    <v-card-text class="pb-lg-40">
                                        <p v-html="item.texts" class="page-text page-text--lg white--text" />
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </template>
                    </v-row>
                </v-container>
            </section>
        </div>

        <div class="client-content-wrap">
            <section class="client-section">
                <v-container>
                    <div class="section-title-wrap" >
                        <h2 class="section-title">자주 묻는 질문</h2>
                    </div>

                    <faq-list :items="faq" legacy />
                </v-container>
            </section>
        </div>
    </client-page>
</template>

<script>
import GuideVisual from "@/components/client/guide/guide-visual.vue";
import ClientPage from "../templates/ClientPage.vue";
import ScrolldownTail from "@/components/dumb/scrolldown-tail.vue";
import SponsorSlide from "@/components/client/dumb/sponsor-slide.vue";
import GoodsTabs from "@/components/client/guide/goods-tabs.vue";
import Faq from "../board/community/Faq.vue";
import FaqList from "@/components/client/dumb/faq-list.vue";

export default {
    components: {
        ClientPage,
        GuideVisual,
        ScrolldownTail,
        SponsorSlide,
        GoodsTabs,
        Faq,
        FaqList,
    },
    data() {
        return {
            visual: {
                image: "/images/guide/legacy/visual.jpg",
                title: "미래를 여는 유산, <br />세대를 잇는 기부",
                texts: "유산기부는 후원자님의 소중한 뜻을 영원히 기리고, <br />미래 세대에게 희망을 선물하는 나눔입니다. <br />후원자님의 재산을 공익에 기부함으로써 <br />사회에 지속 가능한 변화를 이끌어 갑니다.",
                legacy: true,
                mobile: "/images/guide/legacy/mobile-visual.jpg",
            },

            types: [
                {
                    icon: "/images/guide/legacy/type-1.svg",
                    name: "현금",
                },
                {
                    icon: "/images/guide/legacy/type-2.svg",
                    name: "부동산",
                },
                {
                    icon: "/images/guide/legacy/type-3.svg",
                    name: "보험",
                },
                {
                    icon: "/images/guide/legacy/type-4.svg",
                    name: "증권",
                },
                {
                    icon: "/images/guide/legacy/type-5.svg",
                    name: "신탁",
                },
                {
                    icon: "/images/guide/legacy/type-6.svg",
                    name: "귀중품",
                },
            ],

            process: [
                {
                    name: "유산기부 상담",
                    text: "개인 상황에 맞춰 <br class='d-none d-xl-block' />기부 형태와 절차를 <br class='d-none d-xl-block' />논의합니다.",
                },
                {
                    name: "기부서약",
                    text: "유언장 작성 및 유언내용 <br class='d-none d-xl-block' />공증을 진행하여 기부를 <br class='d-none d-xl-block' />서약합니다.",
                },
                {
                    name: "유산기부 전달식",
                    text: "재단과 협약서를 작성하고 <br class='d-none d-xl-block' />구체적인 실행 방안을 <br class='d-none d-xl-block' />확정합니다.",
                },
                {
                    name: "클럽등재",
                    text: "법적·행정적 절차에 따라 <br class='d-none d-xl-block' />위드캔 레거시 클럽에 <br class='d-none d-xl-block' />등재합니다.",
                },
                {
                    name: "유산기부 사업수행 보고",
                    text: "전달된 유산의 사용내역을 <br class='d-none d-xl-block' />공유하고, 후원 결과를 <br class='d-none d-xl-block' />안내해 드립니다.",
                },
            ],

            respect: [
                {
                    image: "/images/guide/legacy/respect-1.jpg",
                    title: "서약 및 위촉식",
                    texts: "후원자님의 뜻깊은 기부를 <br class='d-none d-xl-block' />영원히 이어갈 수 있도록, <br class='d-none d-xl-block' />그 마음을 담은 서약식을 거행합니다.",
                },
                {
                    image: "/images/guide/legacy/respect-2.jpg",
                    title: "명예의 전당 등재",
                    texts: "후원자님의 기부를 기억하고 추모하기 위해 <br class='d-none d-xl-block' />위드캔복지재단 온/오프라인 명예의 전당에 <br class='d-none d-xl-block' />등재합니다.",
                },
                {
                    image: "/images/guide/legacy/respect-3.jpg",
                    title: "행사 우선 초대",
                    texts: "위드캔복지재단에서 주최하는 행사에 <br class='d-none d-xl-block' />후원자 및 가족이 우선 참여할 수 있는 <br class='d-none d-xl-block' />기회를 제공합니다.",
                },
                {
                    image: "/images/guide/legacy/respect-4.jpg",
                    title: "대외홍보",
                    texts: "대외홍보채널을 통해 후원자님의 <br class='d-none d-xl-block' />고귀한 기부를 널리 알리며, <br class='d-none d-xl-block' />후원스토리를 소개합니다.",
                },
                {
                    image: "/images/guide/legacy/respect-5.jpg",
                    title: "장례 지원",
                    texts: "후원자님께서 돌아가셨을 때 장제용품 및 <br class='d-none d-xl-block' />근조기 발송 등 예우를 해드립니다.",
                },
            ],

            faq: [
                {
                    Q: "유산기부는 어떻게 하나요?",
                    A: "유산기부는 먼저 가족과의 충분한 합의가 필요합니다. 합의 후, 전문적인 1:1 상담을 통해 기부 방식, 절차, 기부자 예우 등을 상세히 안내받으실 수 있습니다. <br class='d-none d-xl-block' />유산기부의 방법으로는 '유언 공증, 유언 대용 신탁, 보험금 수익자 지정' 등이 있습니다.",
                },
                {
                    Q: "현금 이외에 기타자산도 기부할 수 있나요?",
                    A: "네, 가능합니다. 본인이 소유한 부동산, 증권, 보험 등 매매가 가능한 비현금성 자산도 기부하실 수 있습니다. <br class='d-none d-xl-block' />이와 관련해 기부 방법 및 절차는 전문가와의 상담을 통해 자세히 안내받으실 수 있습니다.",
                },
                {
                    Q: "기부된 유산은 어디에 사용되나요?",
                    A: "후원자님께서 원하시는 분야에 따라 기부금은 소중하게 사용됩니다.",
                    children: [
                        {
                            name: "해외사업",
                            text: "교육, 식수, 식량 지원 등",
                        },
                        {
                            name: "국내사업",
                            text: "위기 아동 지원, 꿈 지원 등",
                        },
                        {
                            name: "긴급구호사업",
                            text: "재난 및 위기 상황에서 필요한 지원 등 기부금은 가장 필요한 곳에 투명하게 배분됩니다.",
                        },
                    ],
                },
                {
                    Q: "유산기부 서약 후에도 자산을 계속 관리하며, 남은 재산을 기부하는 것이 가능할까요?",
                    A: "가능합니다. 후원자님의 자산이 안전하게 관리되면서 계획적인 기부가 이루어질 수 있도록 전문가와 협력하여 적합한 방안을 안내해 드립니다. <br class='d-none d-xl-block' />이를 통해 자산 관리를 유지하며, 잔여 재산을 기부하는 방법도 선택하실 수 있습니다. 공증, 유언 대용 신탁, 보험금 수익자 지정' 등이 있습니다.",
                },
                {
                    Q: "유산기부 시 어떠한 세제 혜택이 있을까요?",
                    A: "「상속세 및 증여세법」에 따르면 다음과 같은 세제 혜택이 있습니다",
                    children: [
                        {
                            name: "상속세 면제",
                            text: "상속이 시작된 달의 말일부터 6개월 이내에 공익법인에 기부된 상속 재산은 상속세 과세가액에 포함되지 않습니다.",
                        },
                        {
                            name: "증여세 면제",
                            text: "생전에 공익법인에 기부된 재산의 가치는 증여세 과세가액에 포함되지 않습니다.",
                        },
                        {
                            text: "이러한 혜택으로 유산기부는 후원자님의 뜻을 기리면서도 실질적인 세금 절감 효과를 누릴 수 있는 기부 방식입니다.",
                        },
                    ],
                },
            ],
        };
    },
};
</script>

<style lang="scss" scoped>
.legacy-color {
    color: #085848;
}
.legacy-accent {
    color: #ddcd8e;
}
.respect-bg {
    background-color: rgba(9, 104, 12, 0.1);
}
.type-card {
    border-radius: 24px;
    background-color: rgba(50, 50, 50, 0.1);
    position: relative;
    &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: calc(100% - 24px);
        height: calc(100% - 24px);
        background-color: #0c312c;
        border-radius: 16px;
        box-shadow: 8px 4px 14px 0 rgba(0, 0, 0, 0.25);
    }
    .v-card__title,
    .v-card__text {
        position: relative;
        z-index: 1;
    }
}
.process-list {
    > [class*="col"] {
        .process-card {
            padding: 40px 14px;
            height: 100%;
            border-radius: 16px;
            max-width: 400px;
            margin: 0 auto;
            word-break: keep-all;
        }
        &:not(:last-child) {
            .process-card {
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    right: 50%;
                    bottom: -28px;
                    transform: translateX(50%) rotate(90deg);
                    width: 24px;
                    height: 24px;
                    background: url(/images/guide/legacy/process-arrow.svg) no-repeat center;
                }
            }
        }
    }
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
    .process-list {
        > [class*="col"] {
            flex-basis: 20%;
            &:not(:last-child) {
                .process-card {
                    position: relative;
                    &::after {
                        content: "";
                        position: absolute;
                        right: -32px;
                        bottom: 50%;
                        transform: translatey(50%);
                        width: 24px;
                        height: 24px;
                    }
                }
            }
        }
    }
}
</style>